module.exports = __webpack_public_path__ + "img/20200613_094419.e9fa29d0.jpg";